module.exports = __webpack_public_path__ + "img/zhu6.fe63d204.png";